import $ from 'jquery';
import { ReviewApi } from '../api/apicollection';

export default function ReviewViewModel() {
    this.reviews = ko.observableArray([]);
    this.shownReviews = ko.observableArray([]);

    this.getCiteLine = (review) => {
        let date = new Date(review.dateReviewed);
        let dateNoTime = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`
        let citeString =
            `- ${review.customerFirstName.charAt(0).toUpperCase() +
            review.customerFirstName.slice(1).toLowerCase()}
            ${review.customerLastName.charAt(0).toUpperCase()} | ${dateNoTime}`;
        return citeString;
    }

    this.showAll = () => {
        this.shownReviews(this.reviews);
    }

    this.getOverallRating = () => {
        let reviews = this.reviews();
        let total = 0;
        reviews.forEach((review) => { total = total + review.rating });
        let stars = (total / reviews.length)/2;

        return stars;
    }

    this.Load = () => {
        ReviewApi.getEntityReviews().then(data => {
            $('#reviewLoadingSpinner').hide();
            this.reviews(data.data)
            this.shownReviews(this.reviews().slice(0, document.getElementById("NumberOfReviewsShown").value));
        });
    };
    this.Load()
    return this;
};